import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import partialUser from "@irati/identity/services/fragments/PartialUser"
import wellnessMediaCategory from "@irati/wellness/services/fragments/WellnessMediaCategory"
import reportingHighestSavingPerk from "../fragments/reportingHighestSavingPerk"

const query = gql`
  query getBusinessOverview($businessId: ID!, $duration: String, $teamId: String) {
    reportingBusinessOverview(businessId: $businessId, duration: $duration, teamId: $teamId) {
      overview {
        regions
        teams
        users
        activated
        activatedUsers
        unspentFlexiPointsGbp
        unspentFlexiPointsAud
      }
      costOfLiving {
        flexiPointsGbp
        flexiPointsAud
        perksGbp
        perksAud
        discountVouchers
        rewardPointsGbp
        rewardPointsAud
        digitalVouchersGbp
        digitalVouchersAud
        discountVouchersGbp
        discountVouchersAud
      }
      recognition {
        topReceivedUser {
          user {
            ...partialUser
          }
          total
        }
        topGivingUser {
          user {
            ...partialUser
          }
          total
        }
        totalRecognitions
      }
      valuesAndCelebrations {
        topValues {
          valueId
          usageCount
          name
          icon {
            href
          }
        }
        totalValues
        topCelebration {
          celebrationId
          usageCount
          name
          icon {
            href
          }
        }
        totalCelebrations
      }
      benefits {
        redemptions
        benefits {
          uuid
          redemptions
          companyBenefit {
            thumbnailImage
            cardImage
            brandName
            header
          }
        }
      }
      perks {
        perks {
          ...reportingHighestSavingPerk
        }
        flexi {
          ...reportingHighestSavingPerk
        }
      }
      wellness {
        categories {
          uuid
          category {
            ...wellnessMediaCategory
          }
        }
        categoriesWatched
      }
      showMaximiseUsage
    }
  }
  ${partialUser}
  ${reportingHighestSavingPerk}
  ${wellnessMediaCategory}
`

export const businessOverviewKey = getQueryNames(query)[0]

export default query
